import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Box, Icon, IconButton, Image, Fade } from "@chakra-ui/react";
import { RiChat3Fill } from "react-icons/ri";
import { $Routes } from "@routes";
import { SidebarToggle, Participants } from "@components";
import { useSidebar, useProfile } from "@hooks";
import { selectChatUnreadCount } from "@store/chatSlice";
import { isZoomApp } from "@utils/helpers";
import profileIcon from "@assets/profile.svg";

const SidebarClosed = ({ participants, guests, hostId }) => {
  const [showItems, setShowItems] = useState(false);
  const { isSidebarOpen, handleSidebarToggle, handleTabIndex } = useSidebar();
  const { isAuthenticated } = useProfile();
  const unreadCount = useSelector(selectChatUnreadCount);
  const navigate = useNavigate();

  const handleChatChipClick = () => {
    if (!isSidebarOpen) {
      handleSidebarToggle();
    }
    handleTabIndex(2);
  };

  useEffect(() => {
    let timeoutId;

    if (!isSidebarOpen) {
      timeoutId = setTimeout(() => {
        setShowItems(true);
      }, 300);
    }

    return () => {
      clearTimeout(timeoutId);
    };
  }, [isSidebarOpen]);

  const handleClick = () => {
    if (isZoomApp) {
      navigate($Routes.allAgendaPage);
    }
  };

  return (
    <>
      {showItems && (
        <Fade in={!isSidebarOpen} style={{ height: "100%" }}>
          <Box height="100%">
            {/* 200px icon section + 24px space added by Fade component = 212px */}
            <Box height="calc(100% - 212px)">
              <Box
                display="flex"
                direction="column"
                justifyContent="space-evenly"
                alignItems="center"
                bg="dark.500"
                borderRadius="8px"
                margin="0.75rem auto"
                width="63px"
                height="36px"
                position="sticky"
                top="0.75rem"
              >
                <SidebarToggle />
              </Box>
              <Box
                display="flex"
                direction="column"
                justifyContent="space-between"
                alignItems="center"
                margin="0 auto"
                width="63px"
                height="36px"
                position="sticky"
                top="0.75rem"
              >
                <IconButton
                  size="sm"
                  width="auto"
                  height="7"
                  bg="linear-gradient(268.62deg, #8912CA -50.64%, #3E00EA 73.74%)"
                  aria-label="Pro"
                  icon={<Image boxSize="15px" src={profileIcon} />}
                  _hover={{
                    bg: "linear-gradient(268.62deg, #8912CA -50.64%, #3E00EA 73.74%)",
                  }}
                  _active={{
                    bg: "linear-gradient(268.62deg, #8912CA -50.64%, #3E00EA 73.74%)",
                    transform: "scale(0.98)",
                  }}
                  onClick={handleClick}
                />
                <Box
                  bg="#2A2F57"
                  color="#13D1FB"
                  fontSize="10"
                  fontWeight="extrabold"
                  padding="5px"
                  borderRadius="5px"
                  textAlign="center"
                  width="7"
                  height="7"
                  verticalAlign="middle"
                  lineHeight="1.75"
                >
                  {participants.length}
                </Box>
              </Box>
              {isAuthenticated && (
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  margin="0 auto 14px"
                  width="63px"
                >
                  <Box
                    position="relative"
                    width="28px"
                    height="28px"
                    bg="#2A2F57"
                    borderRadius="5px"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    cursor="pointer"
                    onClick={handleChatChipClick}
                    aria-label="Open chat"
                  >
                    <Icon as={RiChat3Fill} color="link" boxSize="14px" />
                    {unreadCount > 0 && (
                      <Box
                        position="absolute"
                        top="-5px"
                        right="-6px"
                        bg="blue.500"
                        color="dark.500"
                        fontSize="8px"
                        fontWeight="700"
                        borderRadius="7px"
                        padding="1px 4px"
                        lineHeight="1.3"
                        boxShadow="0 0 0 2px var(--chakra-colors-dark-700)"
                      >
                        {unreadCount > 9 ? "9+" : unreadCount}
                      </Box>
                    )}
                  </Box>
                </Box>
              )}
              {/* 36px sidebar toggle + 24px top and bottom marging + 36px attendees section = 96px */}
              <Box height={`calc(100% - 96px)`}>
                <Participants
                  participants={participants}
                  guests={guests}
                  hostId={hostId}
                />
              </Box>
            </Box>
          </Box>
        </Fade>
      )}
    </>
  );
};

export default SidebarClosed;
